import { api } from '../axiosClient';
import type { CountriesResponse } from './countries.types';

const COUNTRIES_PATH = '/expense/country';

export const getCountries = (): Promise<CountriesResponse> => {
  return api.get(COUNTRIES_PATH);
};
